import { PreferenceOption } from '@mark43/cad-api';

export function shouldShowCadSection(
    fields: PreferenceOption[],
    preferencesToDisplay: string[],
    isFirstResponder: boolean
) {
    if (isFirstResponder) {
        return false;
    }

    return fields.some((field) => preferencesToDisplay.includes(field.preference));
}
